import { Col, Container, Row } from "react-bootstrap";
import KeyValueForm from "../../../Components/Forms/KeyValueForm/KeyValueForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditKeyValueMutation, useGetKeyValueByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";

export default function EditKeyValuePage() {

  const { keyValueId = '' } = useParams()

  const {
    data: keyValueData,
    error: getError,
    isLoading: getIsLoading
  } = useGetKeyValueByIdQuery(keyValueId, { skip: !keyValueId })

  const [
    editKeyValue,
    {
      isLoading: editIsLoading,
      error: editError
    }
  ] = useEditKeyValueMutation()

  const dispatch = useAppDispatch()
  const handleSubmit = async (data: any) => {
    const values: any = {
      ...data
    }
    const updatedKeyValue = await editKeyValue({
      keyValueId,
      keyValueInfo: values
    }).unwrap()
    if (updatedKeyValue._id) {
      dispatch(navigateTo(`/key-value/${updatedKeyValue._id}`))
    }
    return updatedKeyValue
  }

  return (
    <Container>
      <Row>
        <Col>
          <h1>Edit Key Value</h1>
          <hr />
          {getError && (<>{JSON.stringify(getError)}<br /></>)}
          {editError && (<>{JSON.stringify(editError)}<br /></>)}

          {keyValueData && keyValueData._id && !getIsLoading && (
            <KeyValueForm
              initialValues={keyValueData}
              disabled={editIsLoading}
              onSubmit={handleSubmit}
            />
          )}
        </Col>
      </Row>
    </Container>
  )
}